// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"df05c586","977":"9d4a92f1"}[chunkId] + ".chunk.js";
};